import React from "react";
import { Container } from "react-bootstrap";

export default function Welcome() {
  return (
    <Container className="mt-10">
      <h1 className="font-bold text-lg">404</h1>
      <h2 className="font-bold text-lg">Oops! Page Not Found</h2>
      <p className="error-message">
          The page you're looking for seems to have vanished into the digital void.
          You should contact support to help you out and provide you with the correct URL.
        </p>
    </Container>
  );
}
